import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { getProductDetailPageAttrs } from "../apis/product";
import { ProductDetailSlugContext } from "../context";
import { useContext } from "react";
import { IProductDetail } from "../models/productDetail";

// Set staleTime: Infinity,
// There will only be one fetch, and all other invocations will only read from the cache

const useProductDetailPageAttrQuery = (): UseQueryResult<IProductDetail> => {
  const slug = useContext(ProductDetailSlugContext);
  const fetchAttrs = () => {
    return getProductDetailPageAttrs(slug);
  };

  const data = useQuery(["ProductDetailPage", slug], fetchAttrs, {
    staleTime: Infinity,
  });

  return data;
};

export default useProductDetailPageAttrQuery;
